import { useEffect } from "react"
import { useParams, useLocation } from "react-router-dom"

import { DateTime } from "luxon"

import { useNavigateWithParams } from "hooks/navigation/use-navigate-with-params"
import { useLocalStorage } from "hooks/utils/use-local-storage"

/**
 * Custom hook for handling automatic navigation based on checkout state
 * Redirects users to appropriate pages based on their checkout progress and timing
 */
export const useNavigationEffect = () => {
  const { uuid } = useParams();
  const location = useLocation();
  const { localStorageData } = useLocalStorage();
  const navigateWithParams = useNavigateWithParams();
  const isSuccessRoute = location.pathname.includes("success");

  useEffect(() => {
    if (isSuccessRoute) {
      return;
    }

    if (localStorageData) {
      const checkoutCutoff = DateTime.fromMillis(localStorageData.timestamp);

      if (DateTime.now().minus({ hours: 2 }) < checkoutCutoff) {
        navigateWithParams(`/${uuid}/ticket-details`);
      } else {
        navigateWithParams(`/${uuid}/select-tickets`);
      }
    } else {
      navigateWithParams(`/${uuid}/select-tickets`);
    }
  }, [localStorageData, isSuccessRoute, uuid, navigateWithParams])
}